
define('template!pimAddAttributeTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-3">New attribute code: </div>\n    <div class="col-xs-9"><input type="text" value="" name="new-attribute-code" class="new-attribute-code"></div>\n</div>';

}
return __p
};});

